import { render } from "./ParentChildren.vue?vue&type=template&id=45dc29ce"
import script from "./ParentChildren.vue?vue&type=script&lang=js"
export * from "./ParentChildren.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__